<template>
  <div class="page">
    <ActionBar :breadcrumbItems="breadcrumbItems">
      actions
    </ActionBar>

    <div class="page--content">
      ProjectsPage
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import ActionBar from 'components/Actionbar'

export default {
  name: 'ProjectsPage',
  components: {
    ActionBar
  },
  data () {
    return {
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'Projects', title: this.$t('Views.ProjectsPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
